import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Categories.css';
import { getCategories, getAllImages } from '../firebase/dataService';

function Categories() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCategoriesData();
  }, []);

  const loadCategoriesData = async () => {
    try {
      const cats = await getCategories();
      const images = await getAllImages();
      
      const visibleImages = images.filter(img => img.visible !== false);
      
      const counts = {};
      cats.forEach(cat => {
        counts[cat] = visibleImages.filter(img => img.category === cat).length;
      });
      
      setCategories(cats);
      setCategoryCounts(counts);
    } catch (error) {
      console.error('Error loading categories:', error);
      const defaultCategories = [
        'الفقه',
        'العقيدة',
        'الحديث',
        'التفسير وعلوم القرآن',
        'السيرة النبوية',
        'السير والتراجم',
        'الرقائق',
        'الآداب والأخلاق',
        'الوسواس القهري',
        'وصايا علمية',
        'متفرقات'
      ];
      setCategories(defaultCategories);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = (category) => {
    navigate('/', { state: { selectedCategory: category } });
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'الفقه': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
        </svg>
      ),
      'العقيدة': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      'الحديث': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
        </svg>
      ),
      'التفسير وعلوم القرآن': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5zm0 6h5v2H5z"/>
        </svg>
      ),
      'السيرة النبوية': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>
        </svg>
      ),
      'السير والتراجم': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      ),
      'الرقائق': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </svg>
      ),
      'الآداب والأخلاق': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
      ),
      'الوسواس القهري': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
      ),
      'وصايا علمية': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"/>
        </svg>
      ),
      'متفرقات': (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
      )
    };
    return icons[category] || (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
      </svg>
    );
  };

  const getCategoryColor = () => {
    // لون واحد متناسق مع هوية الموقع (نفس لون الهيدر)
    return 'linear-gradient(135deg, rgba(29, 161, 242, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%)';
  };

  if (loading) {
    return (
      <div className="categories-page">
        <div className="loading-container">
          <div className="loader"></div>
          <p>جاري التحميل...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="categories-page">
      <div className="categories-container">
        <div className="categories-header">
          <h1 className="categories-title">
            <svg viewBox="0 0 24 24" fill="currentColor" style={{width: '45px', height: '45px', marginLeft: '10px', verticalAlign: 'middle', color: 'var(--color-navy)', filter: 'drop-shadow(0 4px 8px rgba(27, 39, 68, 0.4))'}}>
              <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"/>
            </svg>
            التصنيفات
          </h1>
          <div className="title-divider"></div>
          <p className="categories-subtitle">اختر التصنيف المناسب لتصفح المواضيع</p>
        </div>

        <div className="categories-grid">
          {categories.map((category, index) => (
            <div
              key={index}
              className="category-card"
              onClick={() => handleCategoryClick(category)}
              style={{ background: getCategoryColor() }}
            >
              <div className="category-icon">{getCategoryIcon(category)}</div>
              <h3 className="category-name">{category}</h3>
              <div className="category-count">
                {categoryCounts[category] || 0} موضوع
              </div>
              <div className="category-arrow">←</div>
            </div>
          ))}
        </div>

        <div className="categories-footer">
          <button className="back-to-home-btn" onClick={() => navigate('/')}>
            ← العودة للرئيسية
          </button>
        </div>
      </div>
    </div>
  );
}

export default Categories;
